import React from 'react'
import { useRouter } from 'next/router'
import { Form, type FormValues } from '@s4l/ds'
import FilterRatings from './FilterRatings'
import { SearchFilters } from '@s4l/stayforlong/property/SearchFilters'
import FilterAccommodation from './FilterAccommodation'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import FilterStars from './FilterStars'
import FilterFacilities from './FilterFacilities'
import FilterPricing from './FilterPricing'
import type { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'
import FilterMealPlans from './FilterMealPlans'
import FilterThemes from './FilterThemes'

interface ISearchFiltersProps {
  OnFilterChange: (filters: FormValues) => void
  defaultFiltersJSON: ReturnType<SearchFilters['toJSON']>
  listOfPriceDistributionJSON: Parameters<(typeof ListOfPriceDistribution)['fromJSON']>[0]
}

const SearchFiltersComponent = ({
  OnFilterChange,
  defaultFiltersJSON,
  listOfPriceDistributionJSON,
}: ISearchFiltersProps) => {
  const defaultFilters = SearchFilters.fromJSON(defaultFiltersJSON).toPrimitives()
  const { query } = useRouter()

  const hasMealPlans = query.ff?.includes('meal_plans')

  return (
    <Form onChange={OnFilterChange} defaultValue={defaultFilters}>
      <FilterPricing
        defaultMaxPrice={defaultFilters.maxPrice}
        defaultMinPrice={defaultFilters.minPrice}
        listOfPriceDistributionJSON={listOfPriceDistributionJSON}
      />
      <Form.Separator />
      <FilterRatings />
      <Form.Separator />
      <FilterStars />
      <Form.Separator />
      {hasMealPlans && (
        <>
          <FilterMealPlans />
          <Form.Separator />
        </>
      )}
      <FilterAccommodation />
      <Form.Separator />
      <FilterFacilities />
      <Form.Separator />
      <FilterThemes />
      <Form.Separator />
    </Form>
  )
}

SearchFiltersComponent.displayName = 'SearchFilters'

export default withErrorBoundary(SearchFiltersComponent)
